import axios from 'axios'
import config from '../config'
import store from '../store'
import https from 'https'

const agent = new https.Agent({
  rejectUnauthorized: false,
});

export default {
  authenticate (email, password) {
    let url = config.apiURL + '/auth/login'
    return axios({
      method: 'post',
      url: url,
      data: {
        email: email,
        password: password
      },
      httpsAgent: agent
    })
  },
  panels () {
    let url = config.apiURL + '/solar-field/1/sector?include=panels'
    return axios({
      method: 'get',
      url: url,
      data: {},
      headers: {
        Authorization: store.state.token
      },
      httpsAgent: agent
    })
  },
  readings(panelId, perPage, page) {
    let url = config.apiURL + '/readings/' + panelId + '?per_page=' + perPage + '&page=' + page
    return axios({
      method: 'get',
      url: url,
      data: {},
      headers: {
        Authorization: store.state.token
      },
      httpsAgent: agent
    })
  },
  newPanelReadings() {
    let url = config.apiURL + '/read-panels'
    return axios({
      method: 'get',
      url: url,
      data: {},
      headers: {
        Authorization: store.state.token
      },
      httpsAgent: agent
    })
  },
  updatePanel(panel) {
    let url = config.apiURL + '/panel/' + panel.id

    let data = {
      code: panel.code,
      description: panel.description,
      position_measurer_type: panel.position_measurer_type,
      power_measurer_type: panel.power_measurer_type,
      position_alert_threshold: panel.position_alert_threshold,
      position_alarm_threshold: panel.position_alarm_threshold,
      power_alert_threshold: panel.power_alert_threshold,
      power_alarm_threshold: panel.power_alarm_threshold,
      latitude: panel.latitude,
      longitude: panel.longitude,
      notify: panel.notify,
      observe: panel.observe,
      power_type: panel.power_type
    }

    if (panel.position_measurer_type === 'EppcPosition') {
      data.position_measurer_params = JSON.stringify({
        baseUrl: panel.position_measurer_params.baseUrl,
        moverId: parseInt(panel.position_measurer_params.moverId)
      })
    }
    if (panel.position_measurer_type === 'Modicon') {
      data.position_measurer_params = JSON.stringify({
        ip: panel.position_measurer_params.ip,
        port: parseInt(panel.position_measurer_params.port),
        startRegister: parseInt(panel.position_measurer_params.startRegister)
      })
    }

    if ((panel.power_measurer_type === 'EppcPowerXantrex') || (panel.power_measurer_type === 'EppcPowerASP')) {
      data.power_measurer_params = JSON.stringify({
        baseUrl: panel.power_measurer_params.baseUrl,
        moverId: parseInt(panel.power_measurer_params.moverId)
      })
    }

    if (panel.power_measurer_type === 'Fronius') {
      data.power_measurer_params = JSON.stringify({
        ip: panel.power_measurer_params.ip,
        port: parseInt(panel.power_measurer_params.port)
      })
    }

    return axios({
      method: 'put',
      url: url,
      data: data,
      headers: {
        Authorization: store.state.token,
      },
      httpsAgent: agent
    })
  },
  loadConfiguration() {
    let url = config.apiURL + '/config'
    return axios({
      method: 'get',
      url: url,
      data: {},
      headers: {
        Authorization: store.state.token,
      },
      httpsAgent: agent
    })
  },
  saveConfiguration(data) {
    let url = config.apiURL + '/config'
    return axios({
      method: 'put',
      url: url,
      data: data,
      headers: {
        Authorization: store.state.token,
      },
      httpsAgent: agent
    })
  },
  counters() {
    let url = config.apiURL + '/counter'
    return axios({
      method: 'get',
      url: url,
      data: {},
      headers: {
        Authorization: store.state.token
      },
      httpsAgent: agent
    })
  },
  countersDownload() {
    let url = config.apiURL + '/counter/excel'
    return axios({
      method: 'get',
      url: url,
      data: {},
      headers: {
        Authorization: store.state.token
      },
      httpsAgent: agent,
      responseType: 'blob'
    })
  },
  averages() {
    let url = config.apiURL + '/average'
    return axios({
      method: 'get',
      url: url,
      data: {},
      headers: {
        Authorization: store.state.token
      },
      httpsAgent: agent
    })
  },
  readingsDownload(panel, from, to) {
    let url = config.apiURL + '/readings/' + panel + '/excel?from=' + from + '&to=' + to
    return axios({
      method: 'get',
      url: url,
      data: {},
      headers: {
        Authorization: store.state.token
      },
      httpsAgent: agent,
      responseType: 'blob'
    })
  },
  allReadingsDownload(from, to) {
    let url = config.apiURL + '/readings/excel?from=' + from + '&to=' + to
    return axios({
      method: 'get',
      url: url,
      data: {},
      headers: {
        Authorization: store.state.token
      },
      httpsAgent: agent,
      responseType: 'blob'
    })
  }
}
